module.exports = __webpack_public_path__ + "img/c4u-logo.dfc07b2d.png";